import { Root, SwitchThumb } from '@radix-ui/react-switch';
import styled from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledReset,
    styledTypography,
} from '@pkg/primitives';

export const StyledSwitch = styled(Root)`
    ${styledReset.borderBox};
    ${styledReset.button};

    position: relative;
    display: inline-flex;
    overflow: hidden;
    flex-shrink: 0;
    height: 20px;
    width: 35px;
    background-color: rgb(255, 255, 255, 0.1);
    border-radius: 999px;
    outline: 2px solid transparent !important;
    outline-offset: 2px;
    transition-property: background-color, outline-color, opacity;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:disabled {
        ${styledInteraction.interactionDisable};
        opacity: 0.8;
    }

    // &:required {}

    &:focus-visible {
        outline-color: ${designColor.brandPurple} !important;
    }

    &:hover {
        background-color: rgb(255, 255, 255, 0.14);
    }

    &:active {
        background-color: rgb(255, 255, 255, 0.14);
    }
`;

export const StyledSwitchThumb = styled(SwitchThumb)`
    position: absolute;
    top: 3px;
    left: 3px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border-radius: 999px;
    background-color: rgb(255, 255, 255, 0.3);
    transition-property: background-color, transform;
    transition-duration: ${duration.fast}ms;
    transition-timing-function: ${easing.cubic};

    ${StyledSwitch}[data-state='checked'] > & {
        background-color: ${designColor.brandPurple};
        transform: translateX(14px);
    }
`;

export const SwitchLabel = styled.label`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};

    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: rgb(255, 255, 255, 0.5);
`;

export const Container = styled.div`
    display: inline-flex;
    gap: 8px;
    align-items: center;
`;
